import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQueryWithReauth';

export interface ConsultantTask {
  id: string;
  title: string;
  status: string;
}

export const consultantTasksApi = createApi({
  reducerPath: 'consultantTasksApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ConsultantTask'],
  endpoints: (builder) => ({
    getTasks: builder.query<ConsultantTask[], void>({
      query: () => ({ url: '/consultant/tasks' }),
      providesTags: ['ConsultantTask'],
    }),
    createTask: builder.mutation<ConsultantTask, Partial<ConsultantTask>>({
      query: (body) => ({ url: '/consultant/tasks', method: 'POST', body }),
      invalidatesTags: ['ConsultantTask'],
    }),
  }),
});

export const { useGetTasksQuery, useCreateTaskMutation } = consultantTasksApi;
